import React, { useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Card, CardContent, LinearProgress, Typography, Avatar, Button, Box, Grid, Chip, InputAdornment, TextField, Switch, IconButton, Modal, CircularProgress } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import { Autocomplete } from '@mui/material';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AppleIcon from '@mui/icons-material/Apple';
import AndroidIcon from '@mui/icons-material/Android';
import AddAdminVersion from './AddAdminVersion';
import CancelIcon from '@mui/icons-material/Cancel';
import EditAdminVersion from './EditAdminVersion';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '22px',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    width: '558px',
    height: 'auto',
    overflow: 'auto',
};
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const useStyles = makeStyles((theme) => ({
    customerAdminDateTimePicker: {
        width: '250px',
        [theme.breakpoints.down('md')]: {
            width: '200px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '195px',
        },
    },
    customerAdminSearchPicker: {
        width: '256px',
        [theme.breakpoints.down('md')]: {
            width: '230px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '190px',
        },
    },
    headerTextFields: {
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '10px',
        marginBottom: '10px',
        [theme.breakpoints.down('md')]: {
            display: 'grid',
            justifyContent: 'flex-start',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            display: 'grid',
            justifyContent: 'flex-start',
        },
    },
    handleSearchStyle: {
        display: 'flex',
        marginTop: '32px',
        gap: '10px',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            marginTop: '1px',
            gap: '10px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            display: 'flex',
            marginTop: '1px',
            gap: '10px',
        },
    },
    MaterialReactTableCustomerSuperAdmin: {
        // [theme.breakpoints.down('md')]: {
        //     width: '1070px',
        // },
        // [theme.breakpoints.between('md', 'xmd')]: {
        //     width: '1150px',
        // },
    },
}));
const AdminVersion = () => {
    const classes = useStyles();
    const theme = useTheme();
    const [getAllVersion, setGetAllVersion] = useState([])
    const [getVersionCount, setGetVersionCount] = useState()
    const [isLoading, setIsLoading] = useState(false);
    const [selectedForceValue, setSelectedForceValue] = useState('');
    const [selectedFilterValue, setSelectedFilterValue] = useState('');
    const [selectedLive, setSelectedLive] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [open, setOpen] = useState(false);
    const [selectedEditId, setSelectedEditId] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [SelectedDeletedId, setSelectedDeletedId] = useState('');
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [logOutModal, setLogOutModal] = React.useState(false);

    const [openConfirmationMandatory, setOpenConfirmationMandatory] = useState(false);
    const [confirmationData, setConfirmationData] = useState({ id: null, newValue: null });
    const [confirmationDataMandatory, setConfirmationDataMandatory] = useState({ id: null, newStatus: null });
    const handleClickClose = () => {
        setOpenDialog(false);
    };
    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    const filterOptions = [
        { value: 'ios_customer_app', label: 'IOS Customer App' },
        { value: 'ios_agent_app', label: 'IOS Agent App' },
        { value: 'android_customer_app', label: 'Android Customer App' },
        { value: 'android_agent_app', label: 'Android Agent App' },
    ];

    const filterLive = [
        { value: 0, label: 'In Review' },
        { value: 1, label: 'Live' },
    ]

    const hardForceOptions = [
        { value: '1', label: 'Mandatory' },
        { value: '0', label: 'Optional ' },
    ]

    const handleClickEdit = (id) => {
        setOpen(true);
        setSelectedEditId(id);
    };
    const columns = [
        {
            enableSorting: false,
            accessorKey: 'id',
            header: 'Sr no',
            size: 40,
            muiTableBodyCellProps: {
                align: 'left',
            },
        },

        {
            enableSorting: false,
            accessorKey: 'version',
            header: 'Version',
            size: 140,
        },
        {
            accessorKey: 'platform',
            header: 'Platform',
            size: 80,
            enableSorting: false,
            Cell: ({ row }) => {
                const platform = row?.original?.platform;
                if (platform) {
                    // Remove underscores and capitalize the first letter of each word
                    const formattedPlatform = platform
                        .split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                        .join(' ');
                    return <span>{formattedPlatform}</span>;
                }
                return null;
            },


        },

        {
            accessorKey: 'is_mandatory',
            header: 'Status',
            size: 80,
            enableSorting: false,
            muiTableBodyCellProps: {
                align: 'left',
            },
            Cell: ({ row }) => {
                const { id, is_mandatory } = row?.original;

                // Handler for switch toggle
                const handleToggle = (event) => {
                    const newStatus = event.target.checked ? 1 : 0;
                    handleForceUpdateToggle(id, newStatus);
                };

                return (
                    <>
                        <span>{is_mandatory === 1 ? 'Mandatory' : 'Optional'}</span>
                        <Switch
                            checked={is_mandatory === 1}
                            onChange={handleToggle}
                            color="primary"
                            inputProps={{ 'aria-label': 'Force Update Toggle' }}
                        />
                    </>

                );
            },
        },
        {
            accessorKey: 'build',
            header: 'Live / In Review',
            size: 80,
            enableSorting: false,
            muiTableBodyCellProps: {
                align: 'left',
            },
            Cell: ({ row }) => {
                const { id, build } = row?.original;
                // Handler for switch toggle
                const handleToggleChange = () => {
                    if (build === "1") {
                        toast.success('build is already in live')
                        return;
                    }
                    const newValue = build === 1 ? 0 : 1; // Toggle between 0 and 1
                    handleUpdateBuild(id, newValue); // Update with new value and row data if needed
                };

                return (
                    <>
                        <Button
                            onClick={handleToggleChange}
                            style={{
                                cursor: 'pointer',
                                backgroundColor: build === '1' ? '#39ab49' : '#336a93',
                                color: 'white',
                                borderRadius: '12px',
                            }}
                        >
                            {build === '1' ? 'Live' : 'In REVIEW'}
                        </Button>
                    </>

                );
            },
        },

        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;
                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },

        {
            id: 'actions',
            enableSorting: false,
            header: 'Action',
            size: 100,
            Cell: ({ row }) => (
                <div style={{ display: 'flex', }}>
                    {/* <IconButton aria-label="view"
                    >
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <EditIcon onClick={() => handleClickEdit(row?.original?.id)} />
                        </div>
                    </IconButton> */}
                    <IconButton
                        onClick={() => handleOpenDeleteModal(row?.original?.id)}
                        aria-label="delete">
                        <DeleteIcon sx={{ color: '#E71D36' }} />
                    </IconButton>
                </div>
            ),
        },
    ];

    const iconMap = {
        'IOS Agent App': <AppleIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'IOS Customers App': <AppleIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Android Agent App': <AndroidIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
        'Android Customers App': <AndroidIcon style={{ color: '#3674c4',  fontSize: '35px', }} />,
    };

    const getVersion = async (selectedForceValue = '', selectedFilterValue = '', selectedLive = '', searchTerm = '') => {
        setIsLoading(true)
        try {
            const res = await LeadService.getAllVersion(selectedForceValue, selectedFilterValue, selectedLive, searchTerm);
            if (res.data.success) {
                setGetAllVersion([]);
                setGetAllVersion(res?.data?.versions);
                setGetVersionCount(res?.data);
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getVersion(selectedForceValue, selectedFilterValue, selectedLive, searchTerm);
    }, [selectedForceValue, selectedFilterValue, selectedLive, searchTerm]);
    // mandatory and optional
    const handleForceUpdateToggle = async (id, newStatus) => {
        if (newStatus === 1) {
            // Open confirmation modal
            setConfirmationDataMandatory({ id, newStatus });
            setOpenConfirmationMandatory(true);
        } else {
            // Directly update force status without modal
            await updateForceStatus(id, newStatus);
        }
    };
    const updateForceStatus = async (id, newStatus) => {
        try {
            setIsLoading(true);
            const res = await LeadService.forcelyUpdateVersion(id, newStatus);
            if (res.data.success) {
                getVersion(selectedForceValue, selectedFilterValue, selectedLive, searchTerm);
                toast.success(`Force update status for ID ${id} has been set to ${newStatus ? 1 : 0}.`);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };
    const handleConfirmationMandatory = async () => {
        const { id, newStatus } = confirmationDataMandatory;
        await updateForceStatus(id, newStatus);
        setOpenConfirmationMandatory(false); // Close the modal
    };
    // Live Confirmation
    const handleCloseConfirmation = () => {
        setOpenConfirmation(false);
        setConfirmationData({ id: null, newValue: null }); // Reset the stored values
    };

    const handleUpdateBuild = (id, newValue) => {
        if (newValue) {
            setConfirmationData({ id, newValue }); // Store id and newValue
            setOpenConfirmation(true);
        }
    };
    const handleConfirmation = async () => {
        try {
            setIsLoading(true)
            const { id, newValue } = confirmationData; // Destructure from state
            const res = await LeadService.makeVersionLive(id, newValue);
            if (res.data.success) {
                getVersion(selectedForceValue, selectedFilterValue, selectedLive, searchTerm);
                toast.success(res.data.message);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false)
            handleCloseConfirmation(); // Close dialog after handling
        }
    }

    const HandleChangeHardForceOptions = (event, newValue) => {
        setSelectedForceValue(newValue ? newValue.value : '');
    }
    const HandleChangeFilter = (event, newValue) => {
        setSelectedFilterValue(newValue ? newValue.value : '');
    }
    const HandleChangeFilterLive = (event, newValue) => {
        setSelectedLive(newValue ? newValue.value : '');
    }
    const handleSearchChange = (event) => {
        setSearchTerm(event?.target?.value);
    };
    const handleClearAllState = () => {
        setSelectedForceValue('');
        setSelectedFilterValue('');
        setSearchTerm('');
        setSelectedLive('');
    }
    const handleClear = () => {
        setSearchTerm('');
    }

    const handleOpenDeleteModal = (id) => {
        setOpenDialog(true);
        setSelectedDeletedId(id);

    }
    const handleDeletedVersion = async () => {
        try {
            setDeleteLoading(true);
            const res = await LeadService.deleteVersion(SelectedDeletedId);
            if (res?.data?.success) {
                toast.success(res?.data?.message);
                setOpenDialog(false);
                getVersion();
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setDeleteLoading(false);
        }
    };


    return (
        <div>
            <div style={{ marginBottom: '15px' }}> {isLoading && <LinearProgress />}</div>
            <div>
                <Grid container spacing={2}>
                    {[
                        { label: 'IOS Agent App', value: getVersionCount?.ios_agent_app_latest_version },
                        { label: 'IOS Customers App', value: getVersionCount?.ios_customer_app_latest_version },
                        { label: 'Android Agent App', value: getVersionCount?.android_agent_app_latest_version },
                        { label: 'Android Customers App', value: getVersionCount?.android_customer_app_latest_version },
                    ]?.map((item, index) => (
                        <Grid item xs={12} sm={3} md={3} lg={3} key={index}>
                            <Card
                                sx={{
                                    borderRadius: '20px',
                                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                    background: 'linear-gradient(#26c7f3, #316ec1)',
                                }}
                            >
                                <CardContent>
                                    <Box style={{ padding: '15px' }}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Avatar
                                                sx={{
                                                    bgcolor:'#fff',
                                                width: { xs: '30px', sm: '50px', md:'50px', lg:'60px' },
                                                height: { xs: '30px', sm: '50px', md:'50px', lg:'60px' },
                                                }}
                                            >
                                                {iconMap[item?.label]}
                                            </Avatar>
                                            <Typography
                                                sx={{
                                                    fontSize: { xs: '20px', sm: '24px' }, // Responsive font sizes
                                                    fontWeight: 'bold',
                                                    color: 'white',
                                                    fontFamily: 'inherit',
                                                }}
                                            >
                                                {item?.value}
                                            </Typography>
                                        </Box>
                                        <Box style={{ marginTop: '20px' }}>
                                            <Typography sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, color: 'white' ,fontWeight: 'bold', fontFamily: 'inherit',}}>{item?.label}</Typography>
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                <Box style={{ marginTop: '30px' }}>
                    <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <Typography style={{ fontSize: '36px', color: '#242222', fontWeight: '700' }} className="services-animated-text">
                                Version
                            </Typography>
                        </div>
                    </Box>

                    <Box className={classes.headerTextFields}>
                        <Box
                            style={{
                                display: 'flex',
                                gap: '5px',
                                flexWrap: 'wrap'
                            }}
                        >
                            <div style={{ marginTop: '32px' }}>
                                <Autocomplete
                                    options={hardForceOptions}
                                    getOptionLabel={(hardForceOptions) => hardForceOptions.label}
                                    renderInput={(params) => <TextField {...params} label="Option" />}
                                    value={hardForceOptions.find((hardForceOptions) => hardForceOptions.value === selectedForceValue) || null}
                                    onChange={HandleChangeHardForceOptions}
                                    disabled={isLoading}
                                    className={classes.customerAdminDateTimePicker}
                                    sx={{
                                        width: {
                                            xs: "150px",
                                            sm: "200px",
                                            md: "250px"
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: '32px' }}>
                                <Autocomplete
                                    options={filterOptions}
                                    getOptionLabel={(filterOptions) => filterOptions.label}
                                    renderInput={(params) => <TextField {...params} label="Platform" />}
                                    value={filterOptions.find((filterOptions) => filterOptions.value === selectedFilterValue) || null}
                                    onChange={HandleChangeFilter}
                                    disabled={isLoading}
                                    className={classes.customerAdminDateTimePicker}
                                    sx={{
                                        width: {
                                            xs: "150px",
                                            sm: "200px",
                                            md: "250px"
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: '32px' }}>
                                <Autocomplete
                                    options={filterLive}
                                    getOptionLabel={(filterLive) => filterLive.label}
                                    renderInput={(params) => <TextField {...params} label="Live and Review" />}
                                    value={filterLive.find((filterLive) => filterLive.value === selectedLive) || null}
                                    onChange={HandleChangeFilterLive}
                                    disabled={isLoading}
                                    className={classes.customerAdminDateTimePicker}
                                    sx={{
                                        width: {
                                            xs: "150px",
                                            sm: "200px",
                                            md: "250px"
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                            <div style={{ marginTop: '32px' }}>
                                <TextField
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    placeholder="Search version.."
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={handleClear}
                                                    aria-label="clear search">
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    className={classes.customerAdminDateTimePicker}
                                    sx={{
                                        width: {
                                            xs: "150px",
                                            sm: "200px",
                                            md: "250px"
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                            </div>
                        </Box>
                        <div>
                            <Box className={classes.handleSearchStyle}>
                                <Button
                                    style={{
                                        width: '30px',
                                        height: '50px',
                                        border: '1px solid gray',
                                        background: '#bababa',
                                        borderRadius: '12px',
                                        fontWeight: 'bold',
                                        marginLeft: '6px',
                                        cursor: 'pointer',
                                        marginTop: '6px',
                                        color: 'black',
                                    }}
                                    sx={{ fontFamily: 'inherit', }}
                                    onClick={handleClearAllState}
                                >
                                    Clear
                                </Button>
                                <div>
                                    <AddAdminVersion
                                        getVersion={getVersion}
                                        setForceValue={setSelectedForceValue}
                                        setFilterValue={setSelectedFilterValue}
                                        setSearch={setSearchTerm}
                                    />

                                </div>
                            </Box>
                        </div>
                    </Box>
                    <ThemeProvider theme={theme}>
                        <GlobalStyles
                            styles={{
                                '::-webkit-scrollbar': {
                                    width: '14px', // Set the desired width for the scrollbar
                                },
                                '::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                                    borderRadius: '10px', // Set the border radius for a rounded effect
                                },
                            }}
                        />
                    </ThemeProvider>
                    <Box className={classes.MaterialReactTableCustomerSuperAdmin}>
                        <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                            <MaterialReactTable
                                columns={columns}
                                data={getAllVersion}
                                state={{ isLoading: isLoading }}
                                muiCircularProgressProps={{
                                    color: 'secondary',
                                    thickness: 5,
                                    size: 55,
                                }}
                                muiSkeletonProps={{
                                    animation: 'pulse',
                                    height: 28,
                                }}
                                enableTopToolbar={false}
                                enableFacetedValues={true}
                                enableStickyHeader={true}
                                enableDensityToggle={false}
                                enableHiding={false}
                                showSkeletons={false}
                                enableColumnFilterModes={false}
                                enableColumnActions={false}
                                enableColumnOrdering={false}
                                enableFullScreenToggle={false}
                                enableColumnFilters={false}
                                enablePagination={false}
                                muiTableBodyRowProps={({ row }) => ({
                                sx: {
                                        background: row.original.is_mandatory === 1
                                        ? 'linear-gradient(#a3d9e8bf, #5391e4c9)' // Gradient for mandatory rows
                                        : '#f5f5f5', // Default background color
                                        backgroundColor: '#f5f5f5', // Default row background color
                                        '&:nth-of-type(odd)': {
                                            backgroundColor: '#ffffff', // Alternate rows with white
                                        },
                                        '&:hover': {
                                            backgroundColor: '#e0e0e0', // Hover effect
                                            cursor: 'pointer'
                                        },
                                    },
                                })}

                            />
                        </Card>
                    </Box>
                </Box>
            </div>

            {/* Delete Confirmation Madal */}
            <Modal
                open={openDialog}
                aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Box
                            sx={{
                                display: 'grid',
                                padding: '10px',
                                gap: '10px',
                            }}
                        >
                            <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                <Box>
                                    <CancelIcon style={{ fontSize: '34px' }} />
                                </Box>
                                <Box style={{ display: 'grid', gap: '10px' }}>
                                    <div>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                                            Are you sure you want to delete this Version?
                                        </span>
                                    </div>
                                    <div>
                                        <span style={{ fontSize: '16px', color: '#252F46' }}>
                                            This action will delete this version permanently, and you can not undo this.
                                        </span>
                                    </div>
                                </Box>
                            </Box>
                        </Box>

                        <Box style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Button
                                onClick={handleClickClose}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: 'white',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: '#252F46',
                                    fontSize: '15px',
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleDeletedVersion}
                                style={{
                                    width: '140px',
                                    height: '43px',
                                    backgroundColor: '#5379BD',
                                    fontWeight: '500',
                                    borderRadius: '4px',
                                    border: ' 1px solid #587DBF',
                                    color: 'white',
                                    fontSize: '15px',
                                }}
                                disabled={deleteLoading}

                            >
                                {deleteLoading && (<CircularProgress sx={{ visibility: deleteLoading ? '' : 'hidden' }} />)}
                                {deleteLoading ? 'Deleting...' : 'Delete'}
                            </Button>

                        </Box>
                    </div>
                </Box>
            </Modal>
            {/* Confirmation Modal live*/}
            <Dialog
                open={openConfirmation}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"

            >
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to make this version live?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmation}>NO</Button>
                    <Button onClick={handleConfirmation} disabled={isLoading}>
                        {isLoading ? 'Processing...' : 'YES'}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Confirmation Modal Mandatory */}
            <Dialog open={openConfirmationMandatory} TransitionComponent={Transition} keepMounted aria-describedby="alert-dialog-slide-description">
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to make this version mandatory?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmationMandatory(false)}>NO</Button>
                    <Button onClick={handleConfirmationMandatory} disabled={isLoading}> {isLoading ? 'Processing...' : 'YES'}</Button>
                </DialogActions>
            </Dialog>

            <EditAdminVersion 
            open={open}
            setOpen={setOpen}
            selectedEditId={selectedEditId}
            getVersion={getVersion}
            selectedForceValue={selectedForceValue}
            selectedFilterValue={selectedFilterValue}
            searchTerm={searchTerm}
            />

            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal}/>
        </div>
    )
}

export default AdminVersion